import functionCommon from "../common/function";
import { checkExportInquiryConstants } from "../constant/checkExportInquiry.constants";
import { commonConstants } from "../constant/common.constants";
import CONSTANT from "../constant/constant";
import { checkExportInquiryService } from "../services/checkExportInquiryData.service";
import { exportFileAction } from "./commonAction";

const _errorCode = CONSTANT.errorCode;

export const inquiryDataCheckExport = (data, exportParam) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(deleteCheck());
        dispatch(loading());
        checkExportInquiryService.get(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    if (res.result.isApprove == commonConstants.APPROVE) {
                        dispatch(
                            exportFileAction(
                                {
                                    urlGetkey: "WorkLog/requestSecretKey",
                                    urlDownfile: "WorkLog/inquiryData",
                                },
                                exportParam
                            )
                        );
                    }
                    break;

                case _errorCode.TOKENExpired:
                    window.location = "/error/404";
                    break;

                case _errorCode.APIInvalids:
                    window.location = "/error/404";
                    break;
                case _errorCode.DBCanNotConnect:
                    window.location = "/error/404";
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(checkExport) {
        return { type: checkExportInquiryConstants.GET_SUCCESS, checkExport };
    }

    function deleteCheck() {
        return { type: checkExportInquiryConstants.GET_DELETE };
    }

    function loading() {
        return { type: checkExportInquiryConstants.GET_LOADING };
    }
};

export const deleteCheckExport = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }

    return (dispatch) => {
        dispatch(deleteCheck());
        function deleteCheck() {
            return { type: checkExportInquiryConstants.GET_DELETE };
        }
    };
};
